import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/hooks/useAuth';
import { PromptSelectionProvider } from '@/hooks/usePromptSelection';
import { ThemeProvider } from '@/hooks/useTheme';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <PromptSelectionProvider>{children}</PromptSelectionProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
